import { render, staticRenderFns } from "./QuickMenuStatic.vue?vue&type=template&id=855b4438&scoped=true&"
import script from "./QuickMenuStatic.vue?vue&type=script&lang=js&"
export * from "./QuickMenuStatic.vue?vue&type=script&lang=js&"
import style0 from "./QuickMenuStatic.vue?vue&type=style&index=0&id=855b4438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855b4438",
  null
  
)

export default component.exports